import React from 'react';
import {Tabs} from 'antd';
import {FileTextOutlined} from '@ant-design/icons';

import PageTitle from '../../../components/page/PageTitle';
import ErrorBoundary from '../../../components/ErrorBoundary';
import AccountInvoices from '../../../components/invoicing/AccountInvoices';
import LegacyInvoices from '../../../components/invoicing/LegacyInvoices';
import {TabItem} from '../../../types/apiTypes';

const Invoices = () => {

    const tabsItems: TabItem[] = [
        {
            label: 'Account Invoices',
            key: '1',
            children: (
                <ErrorBoundary>
                    <AccountInvoices/>
                </ErrorBoundary>
            ),
        },
        {
            label: 'Legacy Invoices',
            key: '2',
            children: (
                <ErrorBoundary>
                    <LegacyInvoices/>
                </ErrorBoundary>
            ),
        },
    ];

    return (
        <>
            <PageTitle title="Invoices" icon={<FileTextOutlined/>}/>
            <Tabs defaultActiveKey="1" items={tabsItems.map(item => ({
                label: item.label,
                key: item.key,
                children: item.children,
            }))}/>
        </>
    );
};

export default Invoices;
